// Version : 0.0.1
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** CREATE RECURRING DEPOSIT PROPOSAL START *********************** */
export const createNewRecurringDeposit = (addData: any) => {
	const data = {
		createRecurringDepositToken: addData,
	};
	const url = `${API_URL}addRecurringDeposit`;
	return makeApiCall(url, data);
};
/** ***************** CREATE RECURRING DEPOSIT PROPOSAL END *********************** */

/** ***************** UPDATE RECURRING DEPOSIT PROPOSAL START *********************** */
export const updateRecurringDeposit = (updateData: any) => {
	const data = {
		RecurringDepositProposalUpdateToken: updateData,
	};
	const url = `${API_URL}updateRecurringDeposit`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE RECURRING DEPOSIT PROPOSAL END *********************** */

/** ***************** FETCH RECURRING DEPOSIT PROPOSAL START *********************** */
export const fetchRecurringDeposit = (fetchData: any) => {
	const data = {
		RecurringDepositProposalFetchToken: fetchData,
	};
	const url = `${API_URL}fetchRecurringDeposit`;
	return makeApiCall(url, data);
};
/** ***************** FETCH RECURRING DEPOSIT PROPOSAL END *********************** */

/** ***************** GET RECURRING DEPOSIT PROPOSAL START *********************** */
export const getRecurringDeposit = (getData: any) => {
	const data = {
		RecurringDepositProposalGetToken: getData,
	};
	const url = `${API_URL}getRecurringDeposit`;
	return makeApiCall(url, data);
};
/** ***************** GET RECURRING DEPOSIT PROPOSAL END *********************** */

/** ***************** DELETE RECURRING DEPOSIT PROPOSAL START *********************** */
export const deleteRecurringDeposit = (deleteData: any) => {
	const data = {
		RecurringDepositProposalDeleteToken: deleteData,
	};
	const url = `${API_URL}deleteRecurringDeposit`;
	return makeApiCall(url, data);
};
/** ***************** DELETE RECURRING DEPOSIT PROPOSAL END *********************** */
